import authService from './authService';
import { apiErrorFrom } from '@/utils/apiError';
import {
  FreightHubConfigDocument,
  FreightHubPackingReport,
  FreightHubReloadResult,
  FreightHubSaveResult,
} from '../types/freightHubConfig';
import { ApiResponse } from '../types/common';

// Hub de Fretes — /shipping/freight-hub-config (ERPApi).
// Permissões: freight_hub_config.read (GET) e freight_hub_config.write (PUT, reload).

class FreightHubConfigService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  async get(): Promise<FreightHubConfigDocument> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.get('/shipping/freight-hub-config');
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao carregar a configuração do Hub de Fretes');
    const data: ApiResponse<FreightHubConfigDocument> = await res.json();
    return data.data!;
  }

  /** Grava o documento inteiro; o backend valida, salva e pede ao hub para recarregar. */
  async save(doc: FreightHubConfigDocument): Promise<FreightHubSaveResult> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.put('/shipping/freight-hub-config', doc);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao salvar a configuração do Hub de Fretes');
    const data: ApiResponse<FreightHubSaveResult> = await res.json();
    return data.data!;
  }

  async reload(): Promise<FreightHubReloadResult> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.post('/shipping/freight-hub-config/reload');
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao recarregar o hub');
    const data: ApiResponse<FreightHubReloadResult> = await res.json();
    return data.data!;
  }

  /** Acurácia do empacotamento (previsto × real por semana e estratégia) + volume efetivo por SKU. */
  async getPackingReport(weeks = 8, top = 50): Promise<FreightHubPackingReport> {
    const apiClient = await this.getApiClient();
    const res = await apiClient.get(`/shipping/freight-hub-config/packing-report?weeks=${weeks}&top=${top}`);
    if (!res.ok) throw await apiErrorFrom(res, 'Erro ao carregar a acurácia do empacotamento');
    const data: ApiResponse<FreightHubPackingReport> = await res.json();
    return data.data!;
  }
}

export const freightHubConfigService = new FreightHubConfigService();
export default freightHubConfigService;
